import React, { FC, useState, useEffect, ReactNode } from 'react'
import AccordionItem from './AccordionItem'
import { useStoreActions } from '@mortgage-pos/ui/store'
type AccordionData = {
  title: string
  content: string | ReactNode
}

interface Props {
  items: Array<AccordionData>
  openIndex?: number
  trackingLocation?: string
}

const Accordion: FC<Props> = ({ items, openIndex, trackingLocation }) => {
  const [openItem, setOpenItem] = useState(openIndex ? openIndex : 0)

  const { elementClicked } = useStoreActions((store) => store.tracking)
  const changeOpenIndex = (index) => () => {
    if (trackingLocation) {
      elementClicked({
        actionOutcome: 'Expand Accordion',
        elementType: 'Button',
        text: items[index].title,
        location: trackingLocation,
      })
    }
    setOpenItem(index)
  }

  useEffect(() => {
    setOpenItem(openIndex)
  }, [openIndex])

  if (!items) return null
  return (
    <div className="accordion__container">
      {items.map((value, i) => {
        return (
          <AccordionItem
            {...value}
            key={`${value.title}-${i}`}
            isOpen={i === openItem}
            onChange={changeOpenIndex(i)}
          />
        )
      })}
    </div>
  )
}

export default Accordion
